import $ from "jquery";

// spacer size
var navHeight = $('.nav_desktop_b4ba').height();
$('.nav_desktop_b4ba__spacer').css({'height': navHeight + 'px'})
$('.nav_desktop_b4ba__dropdown_megas').slideUp(0);

// dropdown-mega
$('.nav_desktop_b4ba__menu > ul > li').on('mouseenter', function(){
  var $li = $(this);
  
  if($li.hasClass('dropdown_mega')) {
    var data_dropdown_mega = $li.attr('data-dropdown-mega');
    //console.log("has class dropdown mega 4");

    $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
    $('.nav_desktop_b4ba__dropdown_megas [data-dropdown-mega="' + data_dropdown_mega + '"]').addClass('show_dropdown_mega');
    $('.nav_desktop_b4ba__dropdown_megas').stop().slideDown(300);
    $('.fullscreen-overlay').fadeIn(300);
  } else {
    //console.log("does not have class dropdown mega 5");
    $('.fullscreen-overlay').fadeOut(300);
    $('.nav_desktop_b4ba__dropdown_megas').stop().slideUp(300, function() {
      $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');

    });
  }
});

// dropdown
$('.nav_desktop_b4ba__menu > ul > li').on('mouseenter', function(){
  var $li = $(this);
  
  if($li.hasClass('dropdown')) {
    //console.log("Has dropdown 1");
    $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
    $li.addClass('show_dropdown');
  } else {
    //console.log("does not have dropdown 2");
    $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
  }
});


// dropdown-mega
$('.nav_desktop_b4ba__menu .menu_item').on('mouseenter', function(){
  var $li = $(this);
  
  if($li.hasClass('dropdown_mega')) {
    var data_dropdown_mega = $li.attr('data-dropdown-mega');
    //console.log("has class dropdown mega 4");

    $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
    $('.nav_desktop_b4ba__dropdown_megas [data-dropdown-mega="' + data_dropdown_mega + '"]').addClass('show_dropdown_mega');
    $('.nav_desktop_b4ba__dropdown_megas').stop().slideDown(300);
    $('.fullscreen-overlay').fadeIn(300);
  } else {
    //console.log("does not have class dropdown mega 5");
    $('.fullscreen-overlay').fadeOut(300);
    $('.nav_desktop_b4ba__dropdown_megas').stop().slideUp(300, function() {
      $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');

    });
  }
});

// dropdown
$('.nav_desktop_b4ba__menu .menu_item').on('mouseenter', function(){
  var $li = $(this);
  
  if($li.hasClass('dropdown')) {
    //console.log("Has dropdown 1");
    $('.nav_desktop_b4ba__menu .menu_item').removeClass('show_dropdown');
    $li.addClass('show_dropdown');
  } else {
    //console.log("does not have dropdown 2");
    $('.nav_desktop_b4ba__menu .menu_item').removeClass('show_dropdown');
  }
});



// leave nav
$('.nav_desktop_b4ba').on('mouseleave', function(){
  //console.log("nav has been left 3");
  $('.fullscreen-overlay').fadeOut(300);
  $('.nav_desktop_b4ba__dropdown_megas').stop().slideUp(300, function() {
    $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
    $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
  });
});
